import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
// MEMBER_COUNT_HIDDEN — temporarily hidden: the provider's member count is miscalculated. restore once fixed on the provider's side.
// import { useSelector } from 'react-redux';
import Tabs from 'tailwind-components/Tabs/Tabs';
import { formatCommas, formatMoney } from 'utils/utils';
// MEMBER_COUNT_HIDDEN
// import { getCompany } from 'helpers/getCompanyVariables';

// MEMBER_COUNT_HIDDEN
// const isOneill = getCompany() === 'oneill';

export const COMMISSION_TYPE_TABS = [
  { id: 'All', label: 'All' },
  { id: 'Regular', label: 'Regular' },
  { id: 'Bonus', label: 'Bonus' }
];

function KpiCard({ label, value, sub }) {
  return (
    <div className='flex min-h-0 min-w-0 flex-1 flex-col gap-1 rounded-xl border border-[#d9d9da] bg-white px-5 py-4 basis-[120px] '>
      <span className='text-xs font-medium uppercase tracking-wide text-gray-500'>
        {label}
      </span>
      <span className='min-w-0 wrap-break-word sm:text-2xl font-bold tabular-nums leading-tight text-gray-800 text-base'>
        {value}
      </span>
      {sub && <span className='text-xs text-gray-400'>{sub}</span>}
    </div>
  );
}

KpiCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  sub: PropTypes.string
};

function CommissionsKpiCards({
  data_for_graph,
  commissionType,
  onCommissionTypeChange
}) {
  const totalCommissions = useMemo(
    () =>
      (data_for_graph ?? []).reduce((sum, row) => sum + (row.Total || 0), 0),
    [data_for_graph]
  );

  // MEMBER_COUNT_HIDDEN
  // const { zohoData } = useSelector(state => state.user);

  const ytd = useMemo(() => {
    const currentYear = new Date().getFullYear().toString();
    return (data_for_graph ?? [])
      .filter(row => String(row.name).includes(currentYear))
      .reduce((sum, row) => sum + (row.Total || 0), 0);
  }, [data_for_graph]);

  const topCarrier = useMemo(() => {
    const carrierTotals = {};
    (data_for_graph ?? []).forEach(row => {
      Object.keys(row).forEach(key => {
        if (key === 'name' || key === 'Total') return;
        carrierTotals[key] = (carrierTotals[key] || 0) + (row[key] || 0);
      });
    });
    const sorted = Object.entries(carrierTotals).sort((a, b) => b[1] - a[1]);
    return sorted[0]?.[0] ?? 'N/A';
  }, [data_for_graph]);

  return (
    <div className='bg-white border border-[#d9d9da] rounded-xl p-5 flex flex-col sm:flex-row gap-6 items-start sm:items-center'>
      {/* Left: total + tabs */}
      <div className='flex flex-col gap-3 min-w-[220px]'>
        <span className='text-sm text-gray-500 font-medium uppercase tracking-wide'>
          Total Commissions
        </span>
        <span className='text-4xl font-bold text-gray-900 leading-none'>
          ${formatCommas(totalCommissions)}
        </span>
        <Tabs
          tabs={COMMISSION_TYPE_TABS}
          activeTabId={commissionType}
          onTabChange={onCommissionTypeChange}
        />
      </div>

      {/* Divider */}
      <div className='hidden sm:block w-px bg-[#d9d9da] self-stretch' />

      {/* Right: KPI cards */}
      <div className='flex min-w-0 flex-1 flex-row flex-wrap gap-3'>
        <KpiCard label='YTD' value={formatMoney(ytd)} />
        {/* MEMBER_COUNT_HIDDEN — temporarily hidden: the provider's member count is miscalculated. restore once fixed on the provider's side.
        {isOneill && (
          <KpiCard
            label='Agent Member Count'
            value={formatCommas(zohoData?.Member_Count3 ?? 0)}
          />
        )}
        {isOneill && zohoData?.Position_at_Agency === 'Admin' && (
          <KpiCard
            label='Agency Member Count'
            value={formatCommas(
              zohoData?.agencyData?.Current_Agency_Member_Count_Number ?? 0
            )}
          />
        )}
        */}
        <KpiCard label='Top Carrier' value={topCarrier} />
      </div>
    </div>
  );
}

CommissionsKpiCards.propTypes = {
  data_for_graph: PropTypes.array,
  commissionType: PropTypes.string,
  onCommissionTypeChange: PropTypes.func.isRequired
};

export default CommissionsKpiCards;
